import React from 'react';
import SuiteUsersTable from 'src/components/SuiteUsersTable/SuiteUsersTable';
import Callout from 'src/components/InformationCallout/Callout';
import { variables } from 'src/Tenants';
import { PropertiesForContactsProvider } from 'src/pages/Contacts/ContactsContext/PropertiesForContactsContext';
import { ContactFormProvider } from 'src/SharedCommonContext/ContactFormContext';
import {
  useSuiteUsersPageOrchestrator,
  UseSuiteUsersPageOrchestratorReturn,
} from 'src/pages/Suite/SuiteUsers/CustomHooks/useSuiteUsersPageOrchestrator';
import './suite-users.scss';

interface SuiteUsersProps {
  suite: any;
  property: any;
  onFetchSuiteData: () => void;
}

const SuiteUsersContent = ({
  suite,
  property,
  onFetchSuiteData,
}: SuiteUsersProps) => {
  const orchestrator: UseSuiteUsersPageOrchestratorReturn =
    useSuiteUsersPageOrchestrator({ suite, property, onFetchSuiteData });

  return (
    <>
      {orchestrator.hasAssignedStrataManager && (
        <div className="suite-users-callout">
          <Callout
            variant="info"
            title={`A ${variables.strataManager} has been assigned to this ${variables.suite}`}
            subtitle={`${variables.strataManagers} are managed at the property level — they can't be added or removed here. Use the "Manage ${variables.strataManagers}" option on the property.`}
          />
        </div>
      )}
      <SuiteUsersTable {...orchestrator} />
    </>
  );
};

const SuiteUsers = (props: SuiteUsersProps) => {
  return (
    <ContactFormProvider>
      <PropertiesForContactsProvider>
        <SuiteUsersContent {...props} />
      </PropertiesForContactsProvider>
    </ContactFormProvider>
  );
};

export default SuiteUsers;